import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import CreatePost from "@/components/CreatePost";
import PostCard from "@/components/PostCard";
import StoriesBar from "@/components/StoriesBar";

export default function Feed() {
  const { data: posts = [], isLoading } = useQuery({
    queryKey: ["feed"],
    queryFn: async () => (await api.get("/posts")).data,
  });

  return (
    <div className="space-y-6">
      <StoriesBar />
      <CreatePost />
      {isLoading ? (
        <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 text-[#8012C6] animate-spin" /></div>
      ) : posts.length === 0 ? (
        <div className="bg-card border border-border rounded-2xl p-12 text-center">
          <Sparkles className="w-10 h-10 text-[#C084FC] mx-auto mb-3" />
          <h3 className="font-heading font-bold text-lg">Your feed is empty</h3>
          <p className="text-sm text-muted-foreground mt-1">Be the first to share something with the Xealth community.</p>
        </div>
      ) : (
        posts.map((p) => <PostCard key={p.id} post={p} />)
      )}
    </div>
  );
}
